<mat-card class="card">
  <mat-card-content>
    <mat-progress-bar
      *ngIf="isFormLoading"
      mode="indeterminate"
    ></mat-progress-bar>

    <form class="ix-form-container" [formGroup]="form" (submit)="onSubmit()">
      <ix-fieldset [title]="'General Options' | translate">
        <ix-input
          formControlName="interval"
          type="number"
          [label]="'Check Interval' | translate"
          [required]="true"
          [tooltip]="tooltips.interval"
        ></ix-input>

        <ix-select
          formControlName="powermode"
          [label]="'Power Mode' | translate"
          [required]="true"
          [options]="powermodeOptions$"
          [tooltip]="tooltips.powermode"
        ></ix-select>

        <ix-input
          formControlName="difference"
          type="number"
          [label]="'Difference' | translate"
          [tooltip]="tooltips.difference"
          [required]="true"
        ></ix-input>

        <ix-input
          formControlName="informational"
          type="number"
          [label]="'Informational' | translate"
          [tooltip]="tooltips.informational"
          [required]="true"
        ></ix-input>

        <ix-input
          formControlName="critical"
          type="number"
          [label]="'Critical' | translate"
          [tooltip]="tooltips.critical"
          [required]="true"
        ></ix-input>
      </ix-fieldset>

      <div class="form-actions">
        <button
          mat-button
          type="submit"
          color="primary"
          ixTest="save"
          [disabled]="form.invalid || isFormLoading"
        >
          {{ 'Save' | translate }}
        </button>
      </div>
    </form>
  </mat-card-content>
</mat-card>
